import React from 'react'
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import { EligibleWallet } from 'src/common/api'
import WalletRow from './WalletRow'

interface EligibleWalletsPanelProps {
  wallets: EligibleWallet[]
}

const headSx = { fontSize: 12, fontWeight: 600, color: 'text.secondary', whiteSpace: 'nowrap' }

const EligibleWalletsPanel: React.FC<EligibleWalletsPanelProps> = ({ wallets }) => {
  return (
    <Paper variant="card" sx={{ borderRadius: 1, p: 3, mb: 3 }}>
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <AccountBalanceWalletIcon color="primary" />
        <Typography variant="h6" fontWeight={600} fontSize={16}>
          Eligible Treasury Wallets
        </Typography>
      </Box>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={headSx}>Wallet / Identifier</TableCell>
              <TableCell sx={headSx} align="center">
                Type
              </TableCell>
              <TableCell sx={headSx} align="center">
                Days Eligible
              </TableCell>
              <TableCell sx={headSx} align="right">
                Gross QCAD Earned
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {wallets.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 4, color: 'text.secondary' }}>
                  No eligible treasury wallets this period.
                </TableCell>
              </TableRow>
            ) : (
              <>
                {wallets.map((wallet) => (
                  <WalletRow key={wallet.id} wallet={wallet} />
                ))}
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}

export default EligibleWalletsPanel
